if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector(".quantity__input");
        this.currentVariant = this.querySelector(".product-variant-id");
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const sectionId = this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section;
            if (event.data.sectionId !== sectionId) return;
            this.updateQuantityRules(event.data.sectionId, event.data.html);
            this.setQuantityBoundries();
          }
        );
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity
            ? parseInt(this.input.dataset.cartQuantity)
            : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector(
          ".quantity__rules-cart .loading__spinner"
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`
        )
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector(
              ".quantity__rules-cart .loading__spinner"
            ).classList.add("hidden");
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null)
                current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

// ============================================
// あと払い（ペイディ）
// ============================================
document.addEventListener("DOMContentLoaded", function () {
  const widget = document.querySelector("._paidy-promotional-messaging");
  const productVariants = document.querySelectorAll("input[name=Size]");
  for (let i = 0; i < productVariants.length; i++) {
    productVariants[i].addEventListener("change", function (event) {
      const productVariants = document.querySelectorAll(
        "input[name=Size]:checked"
      );
      var price = meta.product.variants
        .find((variant) => variant.public_title === event.target.value)
        .price.toString()
        .slice(0, -2);
      widget.setAttribute("data-amount", price);
      _paidy && _paidy("pm:refresh");
    });
  }
  const productVariantsChecked = document.querySelectorAll(
    "input[name=Size]:checked"
  );
  if (productVariantsChecked.length > 0) {
    var price = meta.product.variants
      .find(
        (variant) => variant.public_title === productVariantsChecked[0].value
      )
      .price.toString()
      .slice(0, -2);
    widget.setAttribute("data-amount", price);
    _paidy && _paidy("pm:refresh");
  }
});

// ============================================
// アコーディオン
// ============================================
document.addEventListener("DOMContentLoaded", function () {
  const accordionTitles = document.querySelectorAll(".accordion__title");

  accordionTitles.forEach(function (title) {
    title.addEventListener("click", function () {
      const content = this.nextElementSibling;
      const icon = this.querySelector(".accordion__icon");

      if (content.style.display === "block") {
        content.style.display = "none";
        icon.textContent = "+";
      } else {
        content.style.display = "block";
        icon.textContent = "-";
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (event) {
    if (event.target.classList.contains("openPopup")) {
      const targetId = event.target.getAttribute("data-target");
      document.getElementById("overlay").style.display = "block";
      document.getElementById(targetId).style.display = "block";
      document.body.style.overflow = "hidden"; // スクロールを無効にする
    }
  });

  // Close Popup functionality
  document.querySelectorAll(".closePopup").forEach((button) => {
    button.addEventListener("click", function () {
      const popup = this.closest(".popup");

      if (popup.classList.contains("ecocycle_popup")) {
        const popupButton = document.getElementById("popup-button");
        if (popupButton) {
          popupButton.remove();
        }
      }

      popup.style.display = "none";
      document.getElementById("overlay").style.display = "none";
      document.body.style.overflow = "scroll";
    });
  });

  // Close Popup when clicking overlay
  document.querySelectorAll(".overlay").forEach((overlay) => {
    overlay.addEventListener("click", function () {
      document.getElementById("overlay").style.display = "none";

      document.querySelectorAll(".popup").forEach((popup) => {
        if (popup.classList.contains("ecocycle_popup")) {
          const popupButton = document.getElementById("popup-button");
          if (popupButton) {
            popupButton.remove();
          }
        }
        popup.style.display = "none";
      });

      document.body.style.overflow = "scroll";
    });
  });
});

// ============================================
// 目次ヘッダーの記述
// ============================================
window.addEventListener("DOMContentLoaded", () => {
  const fixed_01 = document.getElementById("fixed_01");
  // 目次ヘッダーが無いページでは何もしない
  if (!fixed_01) return;
  const navLinks = document.querySelectorAll("#js-nav a");

  // 現在のページパスを取得
  const currentPath = window.location.pathname;
  const isTargetPage = currentPath.includes('/products/pillow_portable');

  // ページに応じてセクションIDリストを変更
  const sectionIds = isTargetPage
    ? ["top", "technology", "scene", "spec", "faq", "reviewWrap"]
    : ["top", "technology", "spec", "faq", "reviewWrap"];

  // 期待するセクション数
  const expectedSectionCount = isTargetPage ? 6 : 5;

  // セクション要素を取得
  const sections = sectionIds
    .map((id) => ({
      id: id,
      element: document.getElementById(id),
    }))
    .filter((item) => item.element);

  if (sections.length === expectedSectionCount) {
    fixed_01.style.display = "flex";

    // スクロール時の処理
    let prevY = window.pageYOffset;

    const updateActiveNav = () => {
      const scrollY = window.pageYOffset;
      let activeId = "top"; // デフォルト

      // 上から順番にチェック
      sections.forEach((section) => {
        // 非表示の要素（テーマ設定でレビューを隠したときの #reviewWrap など）は位置が取れないので飛ばす
        if (section.element.getClientRects().length === 0) return;
        const rect = section.element.getBoundingClientRect();
        const elementTop = scrollY + rect.top;

        // 要素が画面上部から200px以内に来たらアクティブに
        if (scrollY + 200 >= elementTop) {
          activeId = section.id;
        }
      });

      // アクティブクラスの更新
      navLinks.forEach((link) => {
        link.classList.remove("active");
        if (link.getAttribute("href") === `#${activeId}`) {
          link.classList.add("active");
        }
      });
    };

    const handleScroll = () => {
      const currentY = window.pageYOffset;

      // ヘッダー表示制御
      if (currentY === 0) {
        fixed_01.style.position = "relative";
        fixed_01.style.top = "inherit";
      } else {
        fixed_01.style.position = "fixed";

        if (currentY < prevY) {
          const header = document.querySelector(".header");
          const headerHeight = header ? header.offsetHeight : 0;
          fixed_01.style.top = headerHeight + "px";
        } else {
          fixed_01.style.top = "0";
        }
      }

      prevY = currentY;
      updateActiveNav();
    };

    window.addEventListener("scroll", handleScroll);
    updateActiveNav(); // 初期実行
  } else {
    fixed_01.style.display = "none";
  }

  // スムーススクロール
  $('a[href^="#"]').click(function () {
    var speed = 500;
    var href = $(this).attr("href");

    if (href === "#") {
      return false;
    }

    var target = $(href === "" ? "html" : href);
    if (target.length) {
      var position = target.offset().top;
      $("html, body").animate({ scrollTop: position }, speed, "swing");
    }
    return false;
  });
});

// デバッグ用（コンソールで確認可能）
function debugSections() {
  const currentPath = window.location.pathname;
  const isTargetPage = currentPath.includes('/products/pillow_portable');
  const sectionIds = isTargetPage
    ? ["top", "technology", "scene", "spec", "faq", "reviewWrap"]
    : ["top", "technology", "spec", "faq", "reviewWrap"];
  
  console.log('Current page:', currentPath);
  console.log('Is target page:', isTargetPage);
  console.log('Expected sections:', sectionIds);
  
  sectionIds.forEach((id) => {
    const element = document.getElementById(id);
    if (element) {
      console.log(`${id}: 存在します`, element.offsetTop);
    } else {
      console.log(`${id}: 見つかりません`);
    }
  });
}

// ============================================
// カバーガイド・サイズガイドの表示位置調節
// ============================================
document.addEventListener("DOMContentLoaded", function () {
  var guideInfo = document.querySelectorAll(".size-guide_info");
  if (guideInfo.length > 1) guideInfo[0].style.display = "none";
});

// ============================================
// カバーガイド・サイズガイドのポップアップ実装
// ============================================
(function () {
  "use strict";

  // ポップアップ管理
  function initPopup() {
    let activePopup = null;

    // 開くボタンのクリックイベント
    document.addEventListener("click", function (e) {
      const trigger = e.target.closest(".openPopup");
      if (trigger) {
        e.preventDefault();
        const targetId = trigger.getAttribute("data-target");
        openPopup(targetId);
      }
    });

    // 閉じるボタンのクリックイベント
    document.addEventListener("click", function (e) {
      if (e.target.closest(".closePopup")) {
        e.preventDefault();
        closePopup();
      }
    });

    // オーバーレイクリックで閉じる
    document.addEventListener("click", function (e) {
      if (e.target.classList.contains("popup")) {
        closePopup();
      }
    });

    // ESCキーで閉じる
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && activePopup) {
        closePopup();
      }
    });

    // ポップアップを開く
    function openPopup(popupId) {
      const popup = document.getElementById(popupId);
      if (!popup) {
        console.error("Popup not found: " + popupId);
        return;
      }

      // 既存のポップアップを閉じる
      if (activePopup && activePopup !== popup) {
        closePopup();
      }

      // オーバーレイを表示
      const overlay = document.getElementById("overlay");
      if (overlay) {
        overlay.style.display = "block";
      }

      popup.style.display = "block";
      document.body.style.overflow = "hidden";
      activePopup = popup;

      // 閉じるボタンにフォーカス
      const closeButton = popup.querySelector(".closePopup");
      if (closeButton) {
        setTimeout(function () {
          closeButton.focus();
        }, 100);
      }
    }

    // ポップアップを閉じる
    function closePopup() {
      if (!activePopup) return;

      // オーバーレイを非表示
      const overlay = document.getElementById("overlay");
      if (overlay) {
        overlay.style.display = "none";
      }

      activePopup.style.display = "none";
      document.body.style.overflow = "";
      activePopup = null;
    }
  }

  // DOM読み込み完了後に初期化
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPopup);
  } else {
    initPopup();
  }
})();

// ============================================
// 商品ページ「購入する」ボタンの実装
// ============================================
document.addEventListener("DOMContentLoaded", function () {
  const smoothScrollLinks = document.querySelectorAll(".custom-smooth-scroll");
  smoothScrollLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const targetId = this.getAttribute("href");
      const targetElement = document.querySelector(targetId);
      const offset = 20; // スクロール位置を調整するためのオフセット
      const targetPosition =
        targetElement.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    });
  });
});
const header = document.getElementById("ctaBtn");
const target = document.getElementById("custom_product_cta");
const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      header.classList.add("is-hidden");
    } else {
      header.classList.remove("is-hidden");
    }
  });
});
observer.observe(target);

// ============================================
// マットレス設置サービスのCTA内のサービス紹介のアコーディオン
// ============================================
document.addEventListener("DOMContentLoaded", function () {
  jQuery(".js_service_question").click(function () {
    const $btn = jQuery(this);
    const $answer = $btn.next(".js_service_answer");

    if ($answer.is(":visible")) {
      $answer.stop(true).slideUp(300);
      $btn.removeClass("open");
    } else {
      $answer.stop(true).slideDown(300);
      $btn.addClass("open");
    }
  });
});

// ============================================
// サムネイル画像の1枚目のスライドにアイコンを重ねる
// ============================================
document.addEventListener("DOMContentLoaded", () => {
  const slides = document.querySelectorAll(".slider-mobile-gutter li");
  const custom_product_cta = document.getElementById("custom_product_cta");
  const icon = custom_product_cta.querySelector(".authority-icon__wrap");

  if (slides.length > 0 && icon) {
    const firstSlide = slides[0];
    firstSlide.style.position = "relative";
    icon.style.display = "flex";
    firstSlide.appendChild(icon);
  }
});

// ============================================
// ピローのサイズ比較表のアコーディオン
// ============================================
if (jQuery(".accordion_item__question").length) {
  jQuery(".accordion_item__question").click(function () {
    jQuery(this).next(".accordion_item__answer").is(":visible")
      ? (jQuery(this).next(".accordion_item__answer").stop().slideUp(),
        jQuery(this).removeClass("open"))
      : (jQuery(this).next(".accordion_item__answer").stop().slideDown(),
        jQuery(this).addClass("open"));
  });
}

// ============================================
// サイズ比較表のポップアップ
// ============================================
document.addEventListener("DOMContentLoaded", () => {
  const popup = document.getElementById("howtoPopup");

  if (popup) {
    const openBtn = document.getElementById("howtoPopup_open");
    const closeBtn = document.getElementById("closeBtn");
    const body = document.body;

    function openPopup() {
      popup.classList.add("show");
      body.classList.add("no-scroll");
    }

    function closePopup() {
      popup.classList.remove("show");
      body.classList.remove("no-scroll");
    }

    if (openBtn) {
      openBtn.addEventListener("click", openPopup);
    }

    if (closeBtn) {
      closeBtn.addEventListener("click", closePopup);
    }

    popup.addEventListener("click", function (e) {
      if (e.target === popup) {
        closePopup();
      }
    });

    // ESCキーでポップアップを閉じる
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && popup.classList.contains("show")) {
        closePopup();
      }
    });
  }
});

// ============================================
// 価格横の送料無料表記の実装
// ============================================

let isProcessing = false;
let processingTimer = null;

// 価格テキストから数値を抽出
function extractPrice(priceText) {
  const cleaned = priceText.replace(/[¥,円]/g, "").trim();
  return parseInt(cleaned, 10);
}

// 送料無料表示の切り替え
function toggleFreeShipping() {
  const priceElement = document.getElementById("price-sale");
  const freeShippingElement = document.getElementById("Free-Shipping");

  if (!priceElement || !freeShippingElement) return;

  const priceValue = extractPrice(priceElement.textContent);

  if (isNaN(priceValue)) return;

  // 閾値と送料は snippets/free-shipping-note.liquid の data 属性が正
  const threshold = Number(freeShippingElement.dataset.threshold) || 5500;
  const isFree = priceValue >= threshold;
  freeShippingElement.classList.toggle("product__free-shipping--paid", !isFree);
  freeShippingElement.textContent = isFree
    ? "送料無料"
    : "送料550円（5,500円以上で無料）";

  isProcessing = false;
}

// 遅延実行（価格の差し替え直後の連続した変更をまとめる）
function scheduleToggleFreeShipping() {
  if (processingTimer) {
    clearTimeout(processingTimer);
  }

  isProcessing = true;

  processingTimer = setTimeout(function () {
    toggleFreeShipping();
  }, 100);
}

function initFreeShipping() {
  setTimeout(function () {
    toggleFreeShipping();
  }, 100);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initFreeShipping);
} else {
  initFreeShipping();
}

function setupPriceObserver() {
  const priceElement = document.getElementById("price-sale");

  if (!priceElement) return;

  // #price-sale はバリエーション切替のたびに要素ごと差し替わるので、
  // 差し替わらない外側の価格ラッパー（role="status"）を監視する
  const observeTarget = priceElement.closest('[role="status"]') || priceElement;

  const observer = new MutationObserver(function (mutations) {
    scheduleToggleFreeShipping();
  });

  observer.observe(observeTarget, {
    childList: true,
    characterData: true,
    subtree: true,
    characterDataOldValue: true,
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", setupPriceObserver);
} else {
  setupPriceObserver();
}

// Shopifyのバリエーション切り替えイベント
document.addEventListener("variant:change", function (event) {
  scheduleToggleFreeShipping();
});

// カスタムイベント
const customEvents = [
  "variantChange",
  "product:variant-change",
  "variant-change",
];
customEvents.forEach(function (eventName) {
  document.addEventListener(eventName, function () {
    scheduleToggleFreeShipping();
  });
});

// フォーム内のセレクター変更を監視
setTimeout(function () {
  const variantSelectors = document.querySelectorAll(
    'input[name*="id"], select[name*="id"], input[type="radio"]'
  );

  variantSelectors.forEach(function (selector) {
    selector.addEventListener("change", function () {
      scheduleToggleFreeShipping();
    });
  });
}, 500);

function setupParentObserver() {
  const priceElement = document.getElementById("price-sale");
  if (!priceElement) return;

  const parentElement =
    priceElement.closest('.price, .product-price, [class*="price"]') ||
    priceElement.parentElement;

  if (!parentElement) return;

  const parentObserver = new MutationObserver(function (mutations) {
    const relevantChanges = mutations.filter(function (m) {
      return (
        m.target === priceElement ||
        (m.target.id && m.target.id === "price-sale") ||
        (m.target.querySelector && m.target.querySelector("#price-sale"))
      );
    });

    if (relevantChanges.length > 0) {
      scheduleToggleFreeShipping();
    }
  });

  parentObserver.observe(parentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", setupParentObserver);
} else {
  setupParentObserver();
}

// ============================================
// レビューバッチの位置変更の実装
// ============================================
(function () {
  "use strict";

  // Judge.meバッジをproductTitleの直後に移動する関数
  function relocateJudgeMeBadge() {
    // Judge.meバッジ要素を検索（IDに特定の文字列を含む要素）
    const badgeElement = document.querySelector(
      '[id*="judge_me_reviews_preview_badge_gntk8D"]'
    );

    // productTitle要素を検索
    const productTitle = document.getElementById("productTitle");

    // 両方の要素が存在し、かつバッジがまだ移動していない場合
    if (badgeElement && productTitle) {
      // バッジが既にproductTitleの直後にあるかチェック
      const nextElement = productTitle.nextElementSibling;
      if (nextElement !== badgeElement) {
        // productTitleの直後にバッジを挿入
        productTitle.parentNode.insertBefore(
          badgeElement,
          productTitle.nextSibling
        );
        console.log("Judge.meバッジを移動しました");
      }
    }
  }

  // 初回実行：DOMContentLoaded後
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      // Judge.meの読み込みを待つため少し遅延
      setTimeout(relocateJudgeMeBadge, 500);
    });
  } else {
    // 既にDOMが読み込まれている場合は即実行
    setTimeout(relocateJudgeMeBadge, 500);
  }

  // MutationObserverで動的に追加される要素を監視
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      // 新しいノードが追加された場合
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function (node) {
          // 追加されたノードがJudge.meバッジか、その親要素かチェック
          if (node.nodeType === 1) {
            // Element nodeの場合
            const badge = node.querySelector
              ? node.querySelector(
                  '[id*="judge_me_reviews_preview_badge_gntk8D"]'
                )
              : null;
            if (
              badge ||
              (typeof node.id === "string" &&
                node.id.includes("judge_me_reviews_preview_badge_gntk8D"))
            ) {
              // バッジが見つかったら移動処理を実行
              setTimeout(relocateJudgeMeBadge, 100);
            }
          }
        });
      }
    });
  });

  // body要素全体を監視開始
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
})();

// ============================================
// その他の購入方法ボタンのアコーディオン実装
// ============================================
// アコーディオン機能の実装
(function () {
  "use strict";

  // DOM要素の取得
  const trigger = document.getElementById("otherBuyButtons");
  const content = document.getElementById("otherBuyWrap");

  // 要素が存在しない場合は処理を中断
  if (!trigger || !content) {
    console.warn("Accordion elements not found");
    return;
  }

  // 初期状態: 閉じた状態に設定
  content.classList.remove("other-buy_accordion-open");
  trigger.classList.remove("other-buy_accordion-open");

  // クリックイベントの設定
  trigger.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();

    // 開閉状態のトグル
    const isOpen = content.classList.contains("other-buy_accordion-open");

    if (isOpen) {
      // 閉じる処理
      content.classList.remove("other-buy_accordion-open");
      trigger.classList.remove("other-buy_accordion-open");
      trigger.setAttribute("aria-expanded", "false");
      content.setAttribute("aria-hidden", "true");
    } else {
      // 開く処理
      content.classList.add("other-buy_accordion-open");
      trigger.classList.add("other-buy_accordion-open");
      trigger.setAttribute("aria-expanded", "true");
      content.setAttribute("aria-hidden", "false");
    }
  });

  // キーボード操作対応(Enter/Spaceキー)
  trigger.addEventListener("keydown", function (e) {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      trigger.click();
    }
  });
})();

/**
 * アコーディオン「もっと見る」機能
 * 4つ以上のアコーディオン項目がある場合、4つ目以降を折りたたむ
 */
document.addEventListener("DOMContentLoaded", function () {
  "use strict";

  const accordionContainer = document.getElementById("accordion-more-toggle");

  if (!accordionContainer) {
    return;
  }

  const toggleBtn = accordionContainer.querySelector(".accordion__toggle-btn");

  if (!toggleBtn) {
    return;
  }

  const hiddenItems = accordionContainer.querySelectorAll(".accordion__wrap--hidden");
  const toggleText = toggleBtn.querySelector(".accordion__toggle-text");

  toggleBtn.addEventListener("click", function () {
    const isExpanded = this.getAttribute("aria-expanded") === "true";

    if (isExpanded) {
      hiddenItems.forEach(function (item) {
        item.style.display = "none";
      });
      this.setAttribute("aria-expanded", "false");
      toggleText.textContent = "もっと見る";

      const containerTop =
        accordionContainer.getBoundingClientRect().top + window.pageYOffset;
      const offset = 100;
      window.scrollTo({
        top: containerTop - offset,
        behavior: "smooth",
      });
    } else {
      hiddenItems.forEach(function (item) {
        item.style.display = "block";
      });
      this.setAttribute("aria-expanded", "true");
      toggleText.textContent = "閉じる";
    }
  });
});

// ============================================
// 商品概要（CA-07）
// 説明文の先頭にある <details class="product-summary"> を、アコーディオン枠
// （#accordion-more-toggle）の一番上へ「商品概要」の項目として移す。
// 説明文の先頭に置くのは AI・商品カタログが説明文のテキストを読むため、
// 表示を枠の中にまとめるのは購入ボックス下の見た目を変えないため。
// 枠が無いページでは、その場で折りたたみとして表示する（CSS の --standalone）。
// ============================================
document.addEventListener("DOMContentLoaded", function () {
  // アコーディオンの開閉を束縛する DOMContentLoaded が全部終わってから動かす
  setTimeout(function () {
    const summary = document.querySelector("details.product-summary");
    if (!summary) {
      return;
    }

    const box = document.getElementById("accordion-more-toggle");
    const label = summary.querySelector("summary");
    const titleText = (label && label.textContent.trim()) || "商品概要";

    if (!box) {
      summary.classList.add("product-summary--standalone");
      return;
    }

    const wrap = document.createElement("div");
    wrap.className = "accordion__wrap product-summary-accordion";

    const title = document.createElement("h4");
    title.className = "accordion__title";
    title.textContent = titleText;
    const icon = document.createElement("span");
    icon.className = "accordion__icon";
    icon.textContent = "+";
    title.appendChild(icon);

    const content = document.createElement("div");
    content.className = "accordion__content";
    if (label) {
      label.remove();
    }
    while (summary.firstChild) {
      content.appendChild(summary.firstChild);
    }

    wrap.appendChild(title);
    wrap.appendChild(content);
    box.insertBefore(wrap, box.firstChild);
    summary.remove();

    title.addEventListener("click", function () {
      const isOpen = content.style.display === "block";
      content.style.display = isOpen ? "none" : "block";
      icon.textContent = isOpen ? "+" : "-";
    });
  }, 0);
});
